import React from 'react';
import ServicesSection from './ServicesSection';

const Services: React.FC = () => {
  return <ServicesSection />;
};

export default Services;
